import {
    getAccountApplication,
    listAccountApplications
} from './queries';
import {
    createAccountApplication,
    deleteAccountApplication,
    updateAccountApplication,
} from './mutations';

import {GraphQLQuery,} from '@aws-amplify/api';

import {
    AccountApplication,
    CreateAccountApplication,
    DeleteAccountApplication,
    GetAccountApplication,
    ListAccountApplications,
    UpdateAccountApplication
} from "../types.ts";
import {generateClient} from "aws-amplify/api";


const client = generateClient();


export const fetchRecords = async (filter: object) => {
    const response = await client.graphql<GraphQLQuery<ListAccountApplications>>({
                                                                                     query: listAccountApplications,
                                                                                     variables: {
                                                                                         filter: filter
                                                                                     },
                                                                                 });
    return response.data?.listAccountApplications;
};

export const fetch = async (id: string) => {
    const response = await client.graphql<GraphQLQuery<GetAccountApplication>>({
                                                                                   query: getAccountApplication,
                                                                                   variables: {id: id},
                                                                               });
    return response.data?.getAccountApplication;
};

export const add = async (payload: object) => {
    const response = await client.graphql<GraphQLQuery<CreateAccountApplication>>({
                                                                                      query: createAccountApplication,
                                                                                      variables: {input: payload},
                                                                                  });
    return response.data?.createAccountApplication;
};

export const update = async (_id: string, record: AccountApplication) => {

    delete record.created;
    delete record.updated;

    const response = await client.graphql<GraphQLQuery<UpdateAccountApplication>>({
                                                                                      query: (updateAccountApplication),
                                                                                      variables: {input: record},
                                                                                  });
    return response.data?.updateAccountApplication;
};

export const deleteRecord = async (id: string) => {
    const response = await client.graphql<GraphQLQuery<DeleteAccountApplication>>({
                                                                                      query: (deleteAccountApplication),
                                                                                      variables: {input: {id: id}},

                                                                                  });
    return response.data?.deleteAccountApplication;
};
